// src/i18n/translations/es.js

export default {
  // Elementos generales y acciones
  common: {
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    loading: 'Cargando',
    success: 'Éxito',
    error: 'Error',
    confirm: 'Confirmar',
    warning: 'Advertencia',
    info: 'Información',
    close: 'Cerrar',
    cancel: 'Cancelar',
    changeLanguage: 'Cambiar idioma',
    changingLanguage: 'Cambiando idioma...',
    languageInfoDescription: 'Los cambios de idioma se aplican al instante y se reflejan en todo el contenido. Tu preferencia se guarda automáticamente.',
    quickAccess: 'Acceso rápido',
    closeMenu: 'Cerrar menú',
    tools: 'Herramientas',
    me: 'Yo',
    add: 'Añadir',
    copy: 'Copiar',
    copyLink: 'Copiar enlace',
    share: 'Compartir',
    copyFailed: 'Error al copiar:',
    name: 'Nombre',
    user: 'Usuario',
    continue: 'Continuar',
    processing: 'Procesando...',
    change: 'Cambiar',
    copied: 'Copiado',
    understand: 'Entiendo',
    ok: 'OK',
    back: 'Atrás',
    backToDashboard: 'Volver al Panel',
    digitalDiscipline: 'Disciplina Digital'
  },

  // Eslóganes
  slogan: {
    decentralized: "La primera solución de identidad descentralizada del mundo",
    evolution: "El siguiente paso en la evolución de la identidad",
    control: "Recupera el control de tus datos",
    secure: "La fortaleza segura de tu identidad digital"
  },

  // Configuración
  settings: {
    title: 'Configuración'
  },

  // Digital Discipline section translations
  digitalDiscipline: {
    // Tabs
    activeTab: "Activos",
    completedTab: "Completados",
    statisticsTab: "Estadísticas",
    blockedAppsTab: "Aplicaciones bloqueadas",

    // Goals
    goals: "Objetivos",
    addGoal: "Añadir objetivo",
    activateGoal: "Activar objetivo",
    goalActive: "Objetivo activo",
    completeGoal: "Completar objetivo",
    cancelGoal: "Cancelar objetivo",
    daysRemaining: "{days} días restantes",
    lastDay: "Último día",
    expired: "Expirado",

    // Categories
    productivity: "Productividad",
    health: "Salud",
    learning: "Aprendizaje",
    digitalDetox: "Desintoxicación digital",
    mindfulness: "Atención plena",
    habit: "Hábito",
    other: "Otro",

    // Focus session
    focusSession: "Sesión de concentración",
    startFocus: "Iniciar concentración",
    pauseFocus: "Pausar",
    resumeFocus: "Reanudar",
    endFocus: "Terminar sesión",
    focusComplete: "¡Concentración completada!",
    earnedXP: "¡Has ganado {xp} XP!",
    cancelPenalty: "La cancelación anticipada resultará en una penalización del {penalty}% XP",

    // Time format
    minutesFormat: "{minutes} minutos",

    // Blocked apps
    blockedApps: "Aplicaciones bloqueadas",
    addBlockedApp: "Añadir aplicación bloqueada",
    dailyLimit: "Límite diario",
    blockUntil: "Bloquear hasta",
    category: "Categoría",
    socialMedia: "Redes sociales",
    video: "Video",
    games: "Juegos",

    // Statistics
    screenTime: "Tiempo de pantalla",
    completedGoals: "Objetivos completados",
    focusTime: "Tiempo de concentración",
    earnedPoints: "XP ganados",
    level: "Nivel",
    streak: "Racha",

    // AI suggestions
    aiSuggestions: "Sugerencias de IA",
    tryNow: "Probar ahora",
    dismiss: "Descartar",
  },

  // Navegación y elementos del menú
  nav: {
    dashboard: 'Panel principal',
    profile: 'Perfil',
    digitalVault: 'Bóveda digital',
    settings: 'Configuración',
    twoFA: 'Autenticación de dos factores',
    qrCode: 'Código QR',
    logout: 'Cerrar sesión',
    gameHub: 'Centro de juegos',
    messages: 'Mensajes',
    qr: 'Código QR',
    notifications: 'Notificaciones',
    vault: 'Bóveda digital'
  },

  // Pantalla de bienvenida
  welcome: {
    title: 'Primera identidad descentralizada del mundo',
    subtitle: 'Únete a IDapps y entra en el nuevo mundo',
    loginButton: 'Iniciar sesión',
    signupButton: 'Crear cuenta',
    footer: {
      description: 'Plataforma de identidad descentralizada basada en blockchain',
      version: 'v1.0.1 © 2023-2025 IDapps'
    },
    welcomeTitle: 'Bienvenido',
    heroTitle: 'Tu Identidad,\nReinventada.',
    getStarted: 'Comenzar',
    haveAccount: '¿Ya tienes una cuenta?',
    login: 'Iniciar sesión',
    signInWithApple: 'Iniciar sesión con Apple'
  },

  // Pantalla de inicio de sesión y autenticación
  login: {
    title: 'Primera identidad descentralizada del mundo',
    subtitle: 'Inicia sesión para acceder a tu bóveda digital',
    usernameInput: 'Nombre de usuario o correo electrónico',
    formError: {
      emptyFields: 'Por favor, introduce nombre de usuario y contraseña.',
      default: 'Error al iniciar sesión. Por favor, comprueba tu nombre de usuario y contraseña.',
      demoFailed: 'Error en el inicio de sesión de demostración.'
    },
    loggingIn: 'Iniciando sesión...',
    loginButton: 'Iniciar sesión',
    demoLoginDone: 'Inicio de sesión de demostración completado',
    demoLogin: 'Inicio de sesión de demostración (Desarrollador)',
    forgotPassword: 'Olvidé mi contraseña',
    noAccount: '¿Aún no tienes una cuenta de IDapps?',
    createAccount: 'Crear cuenta',
    loginTitle: 'Iniciar sesión',
    welcomeBack: 'Bienvenido de nuevo',
    username: 'Nombre de usuario',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgot: '¿Olvidaste tu contraseña?',
    submit: 'Iniciar sesión',
    processing: 'Procesando...',
    create: 'Crear identidad',
    error: {
      empty: 'Por favor, completa todos los campos',
      failed: 'Error al iniciar sesión. Comprueba tus credenciales.'
    }
  },

  // Pantalla de registro
  signup: {
    title: 'Primera identidad descentralizada del mundo',
    subtitle: 'Únete a IDapps y entra en el nuevo mundo',
    createIdappsAccount: 'Crear cuenta de IDapps',
    createAccountWithApple: 'CREAR CUENTA CON APPLE',
    createAccountWithFacebook: 'CREAR CUENTA CON FACEBOOK',
    alreadyHaveAccount: '¿Ya tienes una cuenta de IDapps?',
    signupTitle: 'Registrarse',
    confirmPassword: 'Confirmar contraseña',
    phoneNumber: 'Número de teléfono',
    verificationCode: 'Código de verificación',
    continueButton: 'Continuar',

    // New Signup Flow Keys
    nameTitle: "¿Cuál es tu nombre?",
    nameSubtitle: "Esto se mostrará en tu perfil",
    namePlaceholder: "Tu nombre completo",

    emailTitle: "¿Cuál es tu correo electrónico?",
    emailSubtitle: "Lo usaremos para verificar tu cuenta",
    emailPlaceholder: "nombre@ejemplo.com",

    passwordTitle: "Crea una contraseña",
    passwordSubtitle: "Hazla fuerte y única",
    passwordPlaceholder: "Mínimo 8 caracteres",

    confirmTitle: "Confirmar detalles",
    confirmSubtitle: "Asegúrate de que todo esté correcto",

    complete: "Crear cuenta",
    haveAccount: "¿Ya tienes una cuenta?",
    login: "Iniciar sesión",

    error: {
      nameRequired: "El nombre es obligatorio",
      emailRequired: "El correo electrónico es obligatorio",
      emailInvalid: "Dirección de correo electrónico inválida",
      passwordLength: "La contraseña debe tener al menos 8 caracteres",
      generic: "Error en el registro. Por favor, inténtalo de nuevo.",
      empty: 'Por favor, completa todos los campos'
    }
  },

  // Sección de perfil
  profile: {
    personalInfo: 'Información personal',
    bloodType: 'Grupo sanguíneo',
    height: 'Altura',
    weight: 'Peso',
    heightWeight: 'Altura / Peso',
    languages: 'Idiomas',
    contacts: 'Contactos',
    bio: 'Sobre mí',
    editProfile: 'Editar perfil',
    identity: 'Identidad',
    profileTitle: 'Perfil',
    qrId: 'Mi ID QR',
    tattoo: 'Tatuaje',
    shareProfileQR: 'Muestra este código QR para compartir tu perfil',
    profileLinkCopied: 'Enlace de perfil compartido copiado',
    shareProfileDescription: 'Puedes usar este código QR para compartir el perfil de {name}'
  },

  // Seguridad y autenticación
  security: {
    security: 'Seguridad',
    securityStatus: 'Estado de seguridad',
    accountSecure: 'Tu cuenta está segura',
    securityMeasuresActive: 'Todas las medidas de seguridad están activas.',
    twoFactorAuth: 'Autenticación de dos factores',
    active: 'Activo',
    passwordStrength: 'Fortaleza de la contraseña',
    strong: 'Fuerte',
    lastLogin: 'Último inicio de sesión',
    today: 'Hoy',
    manageSecuritySettings: 'Gestionar configuración de seguridad',
    blockchainSecurity: 'Seguridad blockchain',
    blockchainSecurityDesc: 'Tu cuenta está protegida con seguridad adicional mediante la conexión de la cartera blockchain.',
    connectedWallet: 'Cartera conectada',
    securityVerification: 'Verificación de seguridad',
    biometricAuth: 'Autenticación biométrica',
    setupTwoFA: 'Configuración 2FA',
    scanQRCode: 'Escanear código QR',
    enterCode: 'Introducir código',
    recoveryKey: 'Clave de recuperación',
    backupCodes: 'Códigos de respaldo',
    passwordAndSecurity: 'Contraseña y seguridad',
    emailAndContact: 'Correo electrónico y contacto',
    twoFactorAuthTitle: 'Autenticación de dos factores',
    securitySettings: 'Configuración de seguridad',
    endToEndEncryption: 'Cifrado de extremo a extremo',
    enhancedSecurityMode: 'Modo de seguridad mejorada activo',
    maxSecurityMode: 'Modo de seguridad máxima activo',
    endToEndEncryptionAccess: 'Acceso seguro con cifrado de extremo a extremo',
    secure: 'Seguro',
    customQR: 'QR personalizado',
    customQRCodes: 'Códigos QR personalizados',
    customQRDescription: 'Crea códigos QR personalizados para tus enlaces frecuentes y compártelos rápidamente.',
    noCustomQR: 'Aún no tienes códigos QR personalizados.',
    linkName: 'Nombre del enlace',
    addNewQRCode: 'Añadir nuevo código QR',

    // Sección de autenticación de dos factores
    twoFA: {
      // Pestañas
      tabs: {
        setup: 'Configuración',
        codes: 'Códigos',
        backup: 'Respaldo',
        devices: 'Dispositivos'
      },

      // Mensajes de estado
      status: {
        enabled: '2FA activado',
        disabled: '2FA no activado'
      },

      // Mensajes de error
      errors: {
        walletRequired: 'Primero debes conectar tu cartera blockchain para configurar 2FA.',
        setupFailed: 'Ocurrió un error durante la configuración. Por favor, inténtalo de nuevo.',
        invalidCode: 'Por favor, introduce el código de verificación de 6 dígitos.',
        verificationFailed: 'Código de verificación inválido. Por favor, inténtalo de nuevo.',
        generalError: 'Ocurrió un error. Por favor, inténtalo de nuevo.',
        codeRequired: 'Por favor, introduce el código de verificación de seguridad.',
        disableFailed: 'No se pudo desactivar 2FA. El código puede ser incorrecto.',
        passwordTooShort: 'Por favor, introduce una contraseña de al menos 8 caracteres.',
        exportFailed: 'No se pudieron exportar los datos 2FA.',
        noImportData: 'Por favor, introduce los datos 2FA para importar.',
        passwordRequired: 'Por favor, introduce tu contraseña.',
        importFailed: 'No se pudieron importar los datos 2FA. La contraseña puede ser incorrecta.',
        deviceRemoveFailed: 'No se pudo eliminar el dispositivo.'
      },

      // Mensajes de éxito
      success: {
        verified: '¡Verificación exitosa! 2FA activado.',
        disabled: '2FA desactivado con éxito.',
        exported: 'Datos 2FA exportados con éxito.',
        imported: 'Datos 2FA importados con éxito.',
        deviceRemoved: 'Dispositivo eliminado con éxito.',
        deviceVerified: 'Dispositivo verificado con éxito.',
        enabled: '¡2FA activado!',
        enabledDescription: 'La autenticación de dos factores se ha activado con éxito. Tu cuenta ahora está más segura.'
      },

      // Etiquetas generales y descripciones
      decentralized: '2FA descentralizado',
      description: 'La autenticación de dos factores (2FA) añade una capa extra de seguridad a tu cuenta. Esta función asegura que tu cuenta esté protegida incluso si tu contraseña se ve comprometida.',
      scanQRCode: 'Escanear código QR',
      scanQRDescription: 'Escanea el código QR a continuación usando Google Authenticator, Authy o una aplicación de autenticación similar.',
      manualKeyInstructions: 'Si no puedes escanear el código QR, puedes introducir manualmente esta clave:',
      verificationCode: 'Código de verificación',
      enterSixDigitCode: 'Introduce el código de 6 dígitos',
      disableInstructions: 'La autenticación de dos factores está actualmente activada. Para desactivar esta función, introduce un código de verificación de tu aplicación de autenticación.',
      currentCode: 'Código actual',
      codeRefreshTime: 'Se actualiza en {seconds} segundos',
      codeRefreshing: 'Actualizando...',
      backupCodes: 'Códigos de respaldo',
      backupCodesInstructions: 'Puedes usar estos códigos de respaldo cuando no tengas acceso a tu dispositivo 2FA. Cada código solo se puede usar una vez.',
      backupCodesDescription: 'Guarda estos códigos de respaldo en un lugar seguro. Puedes usarlos cuando no tengas acceso a tu aplicación de autenticación.',
      saveBackupCodes: 'Guardar códigos de respaldo',
      blockchainVerification: 'Verificación blockchain',
      blockchainVerificationDescription: 'Tus pruebas de verificación 2FA se almacenan y verifican de forma segura en la blockchain.',
      lastVerification: 'Última verificación',
      timeAgo: 'hace {time} horas',
      verifiedOnPolygon: 'Verificado en la red Polygon',
      proofGenerated: 'Prueba de verificación generada: {proof}...',
      enableFirstToViewCodes: 'Primero debes activar 2FA para ver los códigos de verificación.',
      backupAndRecovery: 'Respaldo y recuperación',
      backupDescription: 'Puedes exportar tus datos 2FA (cifrados) o importar datos previamente respaldados.',
      exportData: 'Exportar datos',
      exportDescription: 'Exporta tus datos 2FA cifrados con una contraseña fuerte. Guarda este archivo en un lugar seguro.',
      password: 'Contraseña',
      passwordPlaceholder: 'Introduce tu contraseña (al menos 8 caracteres)',
      encryptedData: 'Datos cifrados',
      storeDataSafely: 'Guarda estos datos de forma segura. Si olvidas tu contraseña, no podrás recuperar los datos.',
      importData: 'Importar datos',
      importDescription: 'Importa los datos 2FA que exportaste previamente. Esto cambiará tu configuración actual de 2FA.',
      pasteEncryptedData: 'Pega los datos cifrados exportados',
      enterPassword: 'Introduce tu contraseña',
      arweaveBackup: 'Respaldo Arweave',
      arweaveDescription: 'Tus pruebas de verificación 2FA se almacenan cifradas en Arweave. Esto proporciona un respaldo permanente e inmutable.',
      arweaveBackupStarted: 'Proceso de respaldo Arweave iniciado. Esto puede tardar unos minutos.',
      decentralizedStorage: 'Almacenamiento descentralizado',
      arweaveTokenRequired: 'Arweave asegura el almacenamiento permanente e inmutable de tus datos. Se requiere una pequeña cantidad de tokens AR para el proceso de respaldo.',
      verifiedDevices: 'Dispositivos verificados',
      devicesDescription: 'Puedes gestionar tus dispositivos verificados por 2FA aquí.',
      noVerifiedDevices: 'Aún no hay dispositivos verificados.',
      thisDevice: 'Este dispositivo',
      deviceVerificationDescription: 'El dispositivo que estás usando se añade automáticamente a la lista de dispositivos verificados. Comprueba regularmente tus dispositivos y elimina cualquier dispositivo que no reconozcas.',
      deviceConnectionHistory: 'Historial de conexión de dispositivos',
      lastAccess: 'Último acceso: {time}',
      daysAgo: 'hace {days} días',
      weeksAgo: 'hace {weeks} semanas',

      // Tipos de dispositivos
      deviceTypes: {
        mobile: 'Dispositivo móvil',
        desktop: 'Dispositivo de escritorio'
      },

      // Sección de características
      features: {
        highSecurity: {
          title: 'Alta seguridad',
          description: 'Los códigos de autenticación se generan con una clave secreta almacenada en tu dispositivo.'
        },
        easyToUse: {
          title: 'Fácil de usar',
          description: 'Puedes usar cualquier aplicación de autenticación con escaneo de código QR.'
        },
        decentralized: {
          title: 'Descentralizado',
          description: 'Los datos de seguridad se verifican en la blockchain, sin depender de servidores.'
        }
      },

      // Modal de información de recuperación
      recoveryInfo: {
        title: 'Información de recuperación',
        description: 'Con las opciones de recuperación 2FA, puedes acceder a tu cuenta incluso si pierdes tu dispositivo o eliminas tu aplicación:',
        backupCodes: {
          title: 'Códigos de respaldo',
          description: 'Cada código de respaldo es válido para un solo uso. Guarda estos códigos en un lugar seguro.'
        },
        encryptedBackup: {
          title: 'Respaldo cifrado',
          description: 'Puedes exportar tus datos 2FA en forma cifrada. No olvides esta contraseña, de lo contrario, el respaldo no podrá ser utilizado.'
        },
        verifiedDevices: {
          title: 'Dispositivos verificados',
          description: 'Tus dispositivos previamente verificados pueden ayudarte en el proceso de autenticación.'
        }
      },

      // Modal de eliminación de dispositivo
      removeDevice: {
        title: 'Eliminar dispositivo',
        confirmation: '¿Estás seguro de que deseas eliminar este dispositivo?'
      },

      // Botones
      buttons: {
        startingSetup: 'Iniciando configuración',
        startSetup: 'Iniciar configuración 2FA',
        verifying: 'Verificando...',
        verify: 'Verificar',
        disable: 'Desactivar 2FA',
        copyCode: 'Copiar código',
        copyAll: 'Copiar todo',
        generateNewCodes: 'Generar nuevos códigos',
        generateProof: 'Generar prueba de verificación',
        goToSetup: 'Ir a la configuración 2FA',
        export: 'Exportar',
        import: 'Importar',
        backupToArweave: 'Respaldar en Arweave',
        verifyThisDevice: 'Verificar este dispositivo'
      }
    }
  },

  // Bóveda digital y notas
  vault: {
    vault: 'Bóveda',
    notes: 'Notas',
    backups: 'Respaldos',
    addNote: 'Añadir nota',
    searchNotes: 'Buscar notas',
    noteTitle: 'Título de la nota',
    noteContent: 'Contenido de la nota',
    addTag: 'Añadir etiqueta',
    saveNote: 'Guardar nota',
    digitalVaultTitle: 'Bóveda digital',
    endlessNotesTitle: 'Notas infinitas',
    memoryPalace: 'Palacio de la memoria'
  },

  // Configuración de la aplicación
  settings: {
    appSettings: 'Configuración de la aplicación',
    appSettingsDesc: 'Gestionar el comportamiento y las preferencias de la aplicación',
    accountSettings: 'Configuración de la cuenta',
    accountSettingsDesc: 'Gestionar tu información de perfil y preferencias',
    languageSelection: 'Selecciona el idioma',
    selectLanguageDescription: 'Selecciona el idioma que deseas usar para la aplicación.',
    themeAndAppearance: 'Tema y apariencia',
    notificationSettings: 'Configuración de notificaciones',
    languageAndRegion: 'Idioma y región',
    other: 'Otros',
    helpAndSupport: 'Ayuda y soporte',
    aboutAndLegal: 'Acerca de y legal',
    confirmLogout: '¿Quieres cerrar sesión?',
    logoutDescription: 'Estás a punto de cerrar sesión en tu cuenta. Necesitarás iniciar sesión de nuevo.'
  },

  // Información de la cuenta
  account: {
    title: 'Introducir información de la cuenta',
    description: 'Introduce la información de la cuenta para completar el proceso de creación de cuenta.',
    gender: {
      male: 'Hombre',
      female: 'Mujer',
      other: 'Otro'
    },
    error: {
      missingFields: 'Por favor, completa todos los campos obligatorios.',
      passwordMismatch: 'Las contraseñas no coinciden.',
      passwordTooShort: 'La contraseña debe tener al menos 6 caracteres.'
    },
    termsAgreement: 'Al crear una cuenta, aceptas los {terms} y la {privacy}.',
    termsAndConditions: 'Términos y condiciones',
    privacyPolicy: 'Política de privacidad'
  },

  // Sección del panel principal
  dashboard: {
    exhibitions: 'Exhibiciones',
    identity: 'Identidad',
    myFolders: 'Mis carpetas',
    qrIdentity: 'Identidad QR',
    badges: 'Insignias',
    activity: 'Actividad',
    active: 'Activo',
    noItems: 'Aún no hay elementos en esta carpeta',
    addItem: 'Añadir elemento',
    folders: {
      personal: 'Personal',
      health: 'Salud',
      documents: 'Documentos',
      favorite: 'Favoritos'
    },
    emergencyInfo: 'Información de emergencia',
    allergies: 'Alergias',
    healthConditions: 'Condiciones de salud',
    medications: 'Medicamentos',
    emergencyContacts: 'Contactos de emergencia',
    addEmergencyContact: 'Añadir contacto de emergencia',
    personalInfo: 'Información personal'
  },

  // Sección de notificaciones
  notifications: {
    tabs: {
      incoming: 'Entrantes',
      reminders: 'Recordatorios',
      tasks: 'Tareas'
    },
    markAllAsRead: 'Marcar todo como leído',
    new: 'Nuevo',
    goToGame: 'Ir al juego',
    noSearchResults: 'No se encontraron resultados de búsqueda',
    noNotifications: 'Aún no hay notificaciones',
    noReminders: 'Aún no hay recordatorios',
    clearSearch: 'Limpiar búsqueda',
    addReminder: 'Añadir recordatorio',
    loading: 'Cargando notificaciones...',
    reminder: {
      new: 'Nuevo recordatorio',
      title: 'Título',
      titlePlaceholder: 'Título del recordatorio',
      description: 'Descripción',
      descriptionPlaceholder: 'Descripción (opcional)',
      date: 'Fecha',
      time: 'Hora',
      category: 'Categoría',
      priority: 'Prioridad',
      repeat: 'Repetir',
      noRepeat: 'No repetir'
    },
    categories: {
      personal: 'Personal',
      work: 'Trabajo',
      health: 'Salud',
      finance: 'Finanzas',
      entertainment: 'Entretenimiento'
    },
    priorities: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta'
    },
    repeat: {
      daily: '🔄 Todos los días',
      weekly: '🔄 Todas las semanas',
      monthly: '🔄 Todos los meses',
      yearly: '🔄 Todos los años'
    },
    filters: {
      all: 'Todos',
      connections: 'Conexiones',
      messages: 'Mensajes',
      verifications: 'Verificaciones',
      security: 'Seguridad',
      games: 'Juegos',
      system: 'Sistema',
      active: 'Activos',
      completed: 'Completados',
      highPriority: 'Alta prioridad',
      mediumPriority: 'Prioridad media',
      lowPriority: 'Baja prioridad'
    },
    time: {
      justNow: 'Ahora mismo',
      minutesAgo: 'hace {minutes} minutos',
      hoursAgo: 'hace {hours} horas',
      daysAgo: 'hace {days} días',
      today: 'Hoy {time}',
      tomorrow: 'Mañana {time}',
      futureDate: '{date} {time}',
      fullDate: '{day}/{month}/{year}'
    },
    errors: {
      loadFailed: 'Error al cargar los datos de notificación:'
    },
    demo: {
      connectionRequest: 'Te ha enviado una solicitud de conexión',
      idappsVerification: 'Verificación IDapps',
      qrVerified: 'Tu código QR ha sido verificado con éxito',
      securityCenter: 'Centro de seguridad',
      newLogin: 'Se ha iniciado sesión en tu cuenta desde un nuevo dispositivo',
      system: 'Sistema',
      appUpdated: 'La aplicación IDapps ha sido actualizada, descubre las nuevas funciones',
      sentMessage: 'Te ha enviado un mensaje: "Hola, ¿cómo estás?"',
      gameHub: 'IDapps GameHub',
      newGame: '¡Nuevo juego: Crypto Quest está en línea! Torneo iniciado con premio de 50 IDCOIN.',
      connectionAccepted: 'Ha aceptado tu solicitud de conexión',
      reminders: {
        weeklyMeeting: 'Reunión semanal',
        teamMeeting: 'Reunión de equipo - vía Zoom',
        doctorAppointment: 'Cita médica',
        dentalCheckup: 'Revisión dental - Hospital Dental Ciudad',
        bills: 'Facturas',
        utilityBills: 'Pago de facturas de electricidad y agua',
        birthday: 'Cumpleaños',
        mothersBirthday: 'Cumpleaños de mamá - Comprar un regalo',
        gameTournament: 'Torneo GameHub',
        puzzleTournament: 'Torneo de Puzzle Blockchain IDapps'
      }
    },
    tasks: {
      dailyTasks: 'Tareas diarias',
      wakeUp: 'Despertar a las 7am',
      checkEmails: 'Revisar correos',
      reviewProject: 'Revisar plan de proyecto',
      completeGameTasks: 'Completar tareas diarias en IDapps GameHub',
      workSchedule: 'Horario de trabajo',
      projectDevelopment: 'Desarrollo de proyecto',
      meetings: 'Reuniones',
      codeReviews: 'Revisiones de código',
      gameTournament: 'Torneo GameHub',
      upcomingEvents: 'Próximos eventos',
      blockchainMeetup: 'Meetup blockchain',
      web3Conference: 'Conferencia Web3',
      onlineEvent: 'Evento online',
      idappsGameTournament: 'Torneo de juegos IDapps',
      metaverseEvent: 'Evento metaverso',
      goals: 'Objetivos',
      dailyStepGoal: 'Objetivo diario de pasos',
      waterIntake: 'Consumo de agua (ml)',
      workTime: 'Tiempo de trabajo',
      idcoinGoal: 'Objetivo IDCOIN',
      hours: 'horas'
    }
  },

  // Blockchain y conexiones de cartera
  blockchain: {
    connectWallet: 'Conectar cartera',
    walletConnected: 'Cartera conectada',
    walletAddress: 'Dirección de la cartera',
    arweaveSync: 'Sincronización Arweave',
    backupToArweave: 'Respaldar en Arweave',
    permanentStorage: 'Almacenamiento permanente',
    walletTitle: 'Cartera blockchain',
    walletDescription: 'Puedes conectar una cartera blockchain para asegurar tu identidad descentralizada.',
    wallet: 'Cartera'
  },

  // Títulos de pantalla
  screens: {
    dashboardTitle: 'Panel principal',
    qrScannerTitle: 'Escáner de código QR',
    gameHubTitle: 'Centro de juegos',
    messagingTitle: 'Mensajería',
    notificationsTitle: 'Notificaciones',
    forgotPasswordTitle: 'Olvidé mi contraseña',
    chatsTab: 'Chats',
    groupsTab: 'Grupos'
  },

  // Pantalla de mensajería
  messaging: {
    searchChat: 'Buscar chat...',
    noSearchResults: 'No se encontraron resultados de búsqueda',
    noResultsFor: 'No hay resultados para "{searchQuery}"',
    noGroupChats: 'Aún no has creado ningún chat grupal.',
    createNewGroup: 'Crear nuevo grupo',
    encryptionDescription: 'Todos tus mensajes en IDapps están cifrados de extremo a extremo y solo pueden ser leídos por ti y la persona con la que estás chateando.',
    selfDestructMessages: 'Mensajes autodestructivos',
    selfDestructDescription: 'Envía mensajes autodestructivos para tus conversaciones privadas. Se eliminan automáticamente después de ser leídos.',
    activateFeature: 'Activar función',
    aiAssistantPrivacy: 'Privacidad del asistente IA',
    aiPrivacyDescription: 'Tu asistente de mensajería se ejecuta completamente en tu dispositivo y tus datos nunca se envían a ningún servidor.',
    aiAssistantActive: 'Asistente IA activo',
    aiResponseSuggestions: 'Sugerencias de respuesta IA',
    writeMessage: 'Escribe un mensaje...',
    online: 'En línea',
    lastSeen: 'Última vez: Hoy a las 15:42',
    greeting: 'Hola, ¿cómo estás?',
    imGood: 'Estoy bien, ¿y tú?',
    imGoodToo: 'Yo también estoy bien, gracias.',
    sentToYou: 'Te lo he enviado.',
    canYouSendFiles: '¿Puedes enviar los archivos?',
    agreed: 'De acuerdo.',
    projectCostQuestion: 'Hola, ¿podemos hablar sobre el costo del proyecto?',
    whatDoYouThink: 'Claro, ¿qué piensas?',
    priceProposal: 'Creo que 500€ es un precio justo.',
    seeYou: 'De acuerdo, nos vemos.',
    meetingInvite: 'Reunión mañana a las 3pm, ¿puedes unirte?',
    callMeWhenFree: '¿Puedes llamarme cuando estés libre?',
    aiSuggestion1: 'Sí, lo he completado. Te lo enviaré en breve.',
    aiSuggestion2: 'Estoy trabajando en ello, estará listo mañana.',
    aiSuggestion3: 'Aún no lo he terminado, lo completaré esta semana.',
    aiSuggestion4: 'Claro, te llamaré en 10 minutos.',
    aiSuggestion5: 'Estoy en una reunión ahora, ¿puedo llamarte en 1 hora?',
    aiSuggestion6: 'No estoy disponible hoy, ¿puedo llamarte mañana?'
  },

  // Sección GameHub
  gameHub: {
    loadingGames: 'Cargando juegos...',
    play: 'Jugar',
    join: 'Unirse',
    progress: 'Progreso',
    level: 'Nivel {completed}/{total}',
    rewards: 'Recompensas',
    points: 'puntos',
    totalPoints: 'Puntos totales',
    xpProgress: 'XP: {current}/{next}',
    featuredGame: 'Juego destacado',
    categoriesTitle: 'Categorías',
    allGames: 'Todos los juegos',
    seeAll: 'Ver todos',
    dailyLogin: 'Inicio de sesión diario',
    dayStreak: 'Racha de {days} días',
    dailyLoginInfo: 'Gana IDCOIN al iniciar sesión todos los días. ¡Bonificación cuando inicias sesión durante 7 días consecutivos!',
    completed: '{completed}/{total} Completado',
    playerCount: '{count} Jugadores',
    coinReward: '{amount} IDCOIN de recompensa',
    participants: 'Participantes: {count}',
    startingGame: 'Iniciando el juego {title}...',

    errors: {
      loadFailed: 'Error al cargar los datos de GameHub:'
    },

    tabs: {
      games: 'Juegos',
      daily: 'Diario',
      leaderboard: 'Clasificación',
      rewards: 'Recompensas'
    },

    categories: {
      quiz: 'Quiz',
      puzzle: 'Puzzle',
      collection: 'Colección',
      simulation: 'Simulación',
      strategy: 'Estrategia'
    },

    games: {
      cryptoQuest: {
        title: 'Crypto Quest',
        description: '¡Avanza en el mundo crypto, pon a prueba tus conocimientos y gana IDCOIN!'
      },
      blockchainPuzzle: {
        title: 'Puzzle Blockchain',
        description: '¡Resuelve puzzles sobre blockchain, completa contratos inteligentes!'
      },
      nftCollector: {
        title: 'Coleccionista NFT',
        description: '¡Colecciona NFTs raros, completa tu colección y gana recompensas!'
      },
      defiTrader: {
        title: 'Trader DeFi',
        description: '¡Realiza transacciones DeFi con fondos virtuales, desarrolla la mejor estrategia!'
      },
      daoManager: {
        title: 'Gestor DAO',
        description: '¡Gestiona tu DAO, haz crecer la comunidad, toma las decisiones correctas!'
      }
    },

    dailyTasks: {
      title: 'Tareas diarias',
      completeAll: '¡Completa todas las tareas, gana un bonus!',
      completeAllBonus: 'Cuando completes todas las tareas diarias, recibirás un bonus extra de {coins} IDCOIN.',
      completeCryptoQuestLevels: 'Completa 3 niveles en Crypto Quest',
      solveBlockchainPuzzle: 'Resuelve un puzzle en Puzzle Blockchain',
      joinCryptoQuestTournament: 'Únete al torneo de Crypto Quest',
      collectDailyIdcoin: 'Recoge tu recompensa diaria de IDCOIN',
      inviteFriend: 'Invita a un amigo a GameHub'
    },

    tournament: {
      active: 'Torneo activo',
      activeTournaments: 'Torneos activos',
      ended: 'Finalizado',
      daysHoursLeft: '{days} días {hours} horas restantes',
      hoursMinutesLeft: '{hours} horas {minutes} minutos restantes',
      short: 'Torneo',
      joinAndWin: '¡Únete al torneo y ten la oportunidad de ganar {coins} IDCOIN!',
      gameTournament: 'Torneo de {game}'
    },

    leaderboard: {
      yourRank: 'Tu clasificación',
      rankPosition: 'Posición {rank}',
      topPercentage: '¡Estás en el top {percent}%!',
      weekly: 'Semanal',
      allTime: 'Todo el tiempo',
      seeFullList: 'Ver lista completa',
      gameLeaderboards: 'Clasificaciones de juegos',
      you: 'Tú'
    },

    rewards: {
      balance: 'Saldo',
      transfer: 'Transferir',
      transactions: 'Transacciones',
      shop: 'Tienda de recompensas',
      cost: '{amount} IDCOIN',
      daily: 'Diario',
      completion: 'Finalización',
      tournament: 'Torneo',

      items: {
        premium: {
          title: '1 Mes Premium',
          description: 'Experiencia sin anuncios y funciones extra'
        },
        nft: {
          title: 'Objeto NFT',
          description: 'Avatares especiales y objetos digitales'
        },
        xpBoost: {
          title: 'Impulso XP',
          description: 'Puntos de experiencia x2 durante 3 días'
        },
        cryptoGift: {
          title: 'Regalo Crypto',
          description: 'Tarjeta regalo de criptomoneda real'
        }
      }
    },

    achievements: {
      title: 'Logros',
      completed: 'Completado',
      seeAll: 'Ver todos los logros',

      firstGame: 'Primer juego',
      firstGameDesc: 'Juega tu primer juego',
      firstTournament: 'Primer torneo', firstTournamentDesc: 'Únete a un torneo',
      gameMaster: 'Maestro del juego',
      gameMasterDesc: 'Juega 5 juegos diferentes',
      collector: 'Coleccionista',
      collectorDesc: 'Gana 10 insignias de logros'
    }
  },

  // IdentityCircle translations
  identityCircle: {
    title: 'IdentityCircle',
    subtitle: 'Tu capa social de confianza',
    visible: 'Visible',
    hidden: 'Oculto',
    hide: 'Ocultar',
    yourStory: 'Tu Historia',
    invisibleMode: 'Modo Invisible Activo',
    invisibleDesc: 'Estás completamente oculto del círculo.',
    goVisible: 'Hacerse Visible',
    createContent: 'Crear Contenido',

    // Invisible mode enhancements
    invisible: {
      activated: 'Modo Invisible Activado',
      redirecting: 'Redirigiendo al panel en {seconds} segundos...',
      reactivate: '¿Reactivar Modo Invisible?',
      reactivateDesc: 'Estabas previamente en modo invisible. ¿Te gustaría reactivarlo?',
      yes: 'Sí, Volverse Invisible',
      no: 'Permanecer Visible',
      goingInvisible: 'Volviéndose invisible...',
      countdown: 'Redirigiendo en {count}...'
    },

    tabs: {
      feed: 'Feed',
      connections: 'Conexiones',
      projects: 'Proyectos',
      knowledge: 'Conocimiento',
      identity: 'Identidad'
    },

    create: {
      title: 'Crear Contenido',
      text: 'Nota de Texto',
      voice: 'Nota de Voz',
      voiceNote: 'Crear Nota de Voz',
      voiceDescription: 'Graba tu voz y comparte tus pensamientos',
      voiceTitle: 'Título (Opcional)',
      voiceTitlePlaceholder: 'Dale un título a tu nota de voz...',
      newVoiceNote: 'Nueva Nota de Voz',
      voiceDesc: 'Graba y comparte tu voz',
      startRecording: 'Comenzar Grabación',
      stopRecording: 'Detener Grabación',
      reRecord: 'Volver a grabar',
      recordingTime: 'Tiempo de grabación',
      recordingInProgress: 'Grabación en progreso... Presiona el botón de detener para finalizar',
      recordingCompleted: '¡Grabación completada! Listo para compartir',
      recordingInstructions: 'Presiona el botón del micrófono para comenzar a grabar',
      shareVoice: 'Compartir Nota de Voz',
      thought: 'Compartir Pensamiento',
      thoughtDesc: 'Comparte tus ideas y experiencias',
      stats: 'Compartir Estadísticas',
      statsDesc: 'Muestra tu progreso',
      vault: 'Bóveda Digital',
      vaultDesc: 'Ve a tus notas personales',
      image: 'Imagen',
      video: 'Video'
    },

    stats: {
      title: 'Compartir Estadísticas',
      description: 'Comparte tu progreso con tu círculo',
      selected: 'Seleccionado',
      share: 'Compartir',
      addDescription: 'Añadir Descripción',
      descriptionPlaceholder: 'Añadir descripción opcional...',
      shareSuccess: '¡Estadísticas compartidas!'
    },

    thought: {
      shareSuccess: '¡Pensamiento compartido!'
    },

    voice: {
      shareSuccess: '¡Nota de voz compartida!'
    },

    emptyState: {
      title: 'Tu círculo está tranquilo',
      description: '¡Anima tu círculo compartiendo el primer contenido!',
      action: 'Hacer Tu Primera Compartición'
    }
  }
};